export default __webpack_public_path__ + "static/media/hht1_home_img_EP5.b98b7c24.png";